var map = {
	"./de.json": [
		4704,
		"src_assets_i18n_de_json"
	],
	"./en.json": [
		8848,
		"src_assets_i18n_en_json"
	],
	"./es.json": [
		3814,
		"src_assets_i18n_es_json"
	],
	"./pl.json": [
		1832,
		"src_assets_i18n_pl_json"
	],
	"./pt.json": [
		2762,
		"src_assets_i18n_pt_json"
	],
	"./tr.json": [
		2176,
		"src_assets_i18n_tr_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8516;
module.exports = webpackAsyncContext;